import React from 'react';
import Offer from './Offer';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'offer';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <Offer
        key={`${type}-${index}`}
        offer={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
